"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Wrapper class for `ExperimentEvaluator.evaluateExperimentAndLog()` to replace the `window.__TNL_QUEUE__` array after
 * `EgTnlBucket.initialize()` is called. This class must implement `push` with the same signature as `Array.push()`.
 */
var ExposureQueue = function () {
    function ExposureQueue(experimentEvaluator) {
        _classCallCheck(this, ExposureQueue);

        this.experimentEvaluator = experimentEvaluator;
    }

    /**
     * Wrapper function to `evaluateExperimentAndLog` for multiple experiments by id
     *
     * @param {number[]} experimentIds - array of experiment ids to evaluate and log
     **/


    _createClass(ExposureQueue, [{
        key: "push",
        value: function push() {
            var _this = this;

            for (var _len = arguments.length, experimentIds = Array(_len), _key = 0; _key < _len; _key++) {
                experimentIds[_key] = arguments[_key];
            }

            experimentIds.forEach(function (experimentId) {
                _this.experimentEvaluator.evaluateExperimentAndLog(experimentId);
            });
        }
    }]);

    return ExposureQueue;
}();

exports.default = ExposureQueue;
//# sourceMappingURL=ExposureQueue.js.map